/*
 *  Bootstrap Nice Select Persian (Iran) Translation
 *  Author: Kevin Gostomski <kevingostomski2001@gmail.com> 
*/

const localisation = {
    locales: []
}

localisation.locales['fa-IR'] = localisation.locales['fa'] = {
    formatSearch() {
        return "جستجوکردن...";
    },
    formatHelpForTagging() {
        return "برای ایجاد تگ های خود، فیلد ورودی را متمرکز کنید و سپس 'Enter' یا ',' ، یا 'Spacebar' را فشار دهید تا آن را به لیست اضافه کنید.";
    }
}

export default localisation;